import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Placeholder from '../Placeholder';
import media from '../../styles/media.style';

const Wrapper = styled.div`
  margin-top: 50px;

  &:first-child {
    margin-top: 0;
  }

  ${media.tabletL`
    margin-top: 0;
  `};
`;

const Title = styled.h3`
  font-size: 28px;
  text-transform: uppercase;
  width: 100%;
  margin: 0;
  font-weight: 400;
`;

const Text = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5em;
  font-weight: 400;
`;

const KeyIngredient = ({ name, description }) => (
  <Wrapper>
    <Title>{name || <Placeholder w="80%" pb="10%" />}</Title>
    <Text>{description || <Placeholder w="100%" pb="15%" />}</Text>
  </Wrapper>
);

KeyIngredient.defaultProps = {
  name: undefined,
  description: undefined,
};

KeyIngredient.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
};

export default KeyIngredient;



// WEBPACK FOOTER //
// ./src/components/ProductIngredients/KeyIngredient.js